import { createHttpEndpoint } from '../../utils'

import type {
  GetIntegrations,
  GetIntegrationsMetadata,
  PostIntegration,
} from './integrations.types'

/**
 * Retrieves the list of current integration for the authenticated seller
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Integrations/operation/get-bm-merchants-integrations}
 */
export const getIntegrations = createHttpEndpoint<GetIntegrations>({
  method: 'GET',
  operationId: 'getIntegrations',
  path: '/bm/merchants/integrations',
})

/**
 * Create an integration for the seller related to the integrator sent in payload
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Integrations/operation/post-bm-merchants-integrations}
 */
export const postIntegration = createHttpEndpoint<PostIntegration>({
  method: 'POST',
  operationId: 'createIntegration',
  path: '/bm/merchants/integrations',
})

/**
 * Delete an integration for the seller.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Integrations/operation/delete-bm-merchants-integrations}
 */
export const deleteIntegration = createHttpEndpoint({
  method: 'DELETE',
  operationId: 'deleteIntegration',
  path: '/bm/merchants/integrations/:id',
})

/**
 * Retrieves metadata for the integrations page
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Integrations/operation/get-bm-merchants-integrations-metadata}
 */
export const getIntegrationsMetadata =
  createHttpEndpoint<GetIntegrationsMetadata>({
    method: 'GET',
    operationId: 'getIntegrationsMetadata',
    path: '/bm/merchants/integrations/metadata',
  })
